import init from "../../modal/modal";

const initHeaderCart = () => {
  const mainHeaderCarts = document.querySelectorAll<HTMLElement>('.main-header-cart')

  const mobileQuery = window.matchMedia("(max-width: 61.999em)")
  mainHeaderCarts.forEach(item => {
    const openButton = item.querySelector<HTMLElement>('.main-header-cart__button-open');
    const panel = item.querySelector<HTMLElement>('.main-header-cart__panel');
    const closeButton = item.querySelector<HTMLElement>('.i-cart-overview__close-button');

    if (!panel) return

    openButton?.addEventListener('click', () => {
      if (!mobileQuery.matches) return;

      panel?.classList.add('--open')
      document.body.classList.add('--disable-scroll')
    })

    closeButton?.addEventListener('click', () => {
      if (!panel) return;
      panel.style.pointerEvents = "none";
      setTimeout(() => {
        panel.style.removeProperty("pointer-events")
      }, 100);

      if (!mobileQuery.matches) return;

      panel?.classList.remove('--open')
      document.body.classList.remove('--disable-scroll')
    })

    mobileQuery.onchange = () => {
      panel?.classList.remove('--open')
      document.body.classList.remove('--disable-scroll')
    }
  })
}
export const reinitHeaderCart = () => {
  init();

  initHeaderCart()
}

initHeaderCart();
